import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderEN from "../../headerEN/headeren";
import FooterEN from "../../footerEN/footer";
import './serviceexcellence.scss';

const ServiceExcellence = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
      <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="dsk-tab-btn-viewmode-en">
        <div class="servicexcell-tab-imagebannermain-en">
          <div class="servicexcell-banner-con-en">
            <div class="servicexcelltab-banne-sec-en">
              <h1 class="servicexcell-banner-heading-en">Customer Services</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "report-a-claim"}>Report a Claim</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "claim-consultancy-services"}>Claim Consultancy Services</div>
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "service-excellence"}>Service Excellence</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "in-house-kr-automotive-garage"}>In house KR Automotive Garage</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "erp-based-solutions"}>ERP Based Solutions</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="servicexcell-banner-con-en">
          <div class="servicexcell-bdy-en">
            {/* <h2 class="pagetitle-en">Excellence in Service Delivery</h2> */}
            <div class="servicexcell-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="servicexcell-dlex-lft-en">
                <h2 class="pagetitle-en">Service Excellence</h2>

                <p class="servicexcell-pg-txt-con">KR Insurance Services has got functional expertise into advisory services, underwriting, expert claims servicing and client retention services to ensure increased efficiency in the deliverables -  </p>
                
                <div class="servicexcell-keypoint-en">
              <div class="servicexcell-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
              <div class="servicexcell-keypoint-item-en"><u>Advisory services</u> aim to achieve customer delight through dedicated client relationship management, risk inspections, policy audit, route surveys, wellness programs, credit reports renewal reminders etc.</div>

              <div class="servicexcell-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
              <div class="servicexcell-keypoint-item-en"><u>Specialist Underwriting</u> teams to arrange the best terms from insurers and re-insurers, ensuring complete cover of risk in hand.</div>

              <div class="servicexcell-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
              <div class="servicexcell-keypoint-item-en"><u>Expert Claims servicing</u> teams work towards smooth claim settlement across business lines ensuring business continuity.</div>

              <div class="servicexcell-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
              <div class="servicexcell-keypoint-item-en"><u>Dedicated Retention team</u> for exceeding client’s service expectations and retaining clients with us on a year to year basis.</div>
            </div>

                <h3 class="servicexcell-whykrinsu-title-en">Why KR Insurance Services ?</h3>
              <div class="clearfix"></div>

              <div class="servicexcell-pins-list-lftdksp-en">
                <div class="servicexcell-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
                <div class="servicexcell-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
                <div class="servicexcell-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
                <div class="servicexcell-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
              </div>

              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="servicexcell-dlex-rgt-en">
                <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/service_excellence.png"} alt="service excellence" />
              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>
            
            </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* TAB-VIEW AND TABS SECTION STARTS HERE */}
      <div className="tab-btn-viewmode-en">
        <div class="servicexcell-tab-imagebannermain-en">
          <div class="servicexcell-banner-con-en">
            <div class="servicexcelltab-banne-sec-en">
              <h1 class="servicexcell-banner-heading-en">Customer Services</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "report-a-claim"}>Report a Claim</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "claim-consultancy-services"}>Claim Consultancy Services</div>
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "service-excellence"}>Service Excellence</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "in-house-kr-automotive-garage"}>In house KR Automotive Garage</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "erp-based-solutions"}>ERP Based Solutions</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="servicexcell-banner-con-en">
          <div className="tab-imgtxt-en">
            <h2>Service Excellence</h2>
            <div className="tabs-cont-en">
              <img className="rgt-img-en" src={process.env.PUBLIC_URL + "/customer_service/tab_images/service_excellence.png"} alt="service excellence" />
                <p>KR Insurance Services has got functional expertise into advisory services, underwriting, expert claims servicing and client retention services to ensure increased efficiency in the deliverables -  </p>
                <p><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> <u>Advisory services</u> aim to achieve customer delight through dedicated client relationship management, risk inspections, policy audit, route surveys, wellness programs, credit reports renewal reminders etc.</p>
                <p><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> <u>Specialist Underwriting</u> teams to arrange the best terms from insurers and re-insurers, ensuring complete cover of risk in hand.</p>
                <p><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> <u>Expert Claims servicing</u> teams work towards smooth claim settlement across business lines ensuring business continuity.</p>
                <p><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> <u>Dedicated Retention team</u> for exceeding client's service expectations and retaining clients with us on a year to year basis.</p>

                <h3 class="tab-whykrinsu-title-en">Why KR Insurance Services ?</h3>

                <div class="tab-whykrinsu-pins-list-en">
                  <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Competitive Terms</div>
                  <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Prompt Claim Services</div>
                  <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Wide Quote Comparisons</div>
                  <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Best Insurance Industry Practices</div>
                </div>
            </div>
          </div>
        </div>
      </div>
      {/* TAB-VIEW AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="servicexcell-tab-imagebannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"claim-consultancy-services"}>Claim Consultancy Services</option>
            <option value={"service-excellence"} selected class="active">Service Excellence</option>
            <option value={"in-house-kr-automotive-garage"}>In house KR Automotive Garage</option>
            <option value={"erp-based-solutions"}>ERP Based Solutions</option>
          </select>
        </div>
        <div class="servicexcell-mob-main-en">
          <h1 class="servicexcell-banner-heading-en">Service Excellence</h1>
          <div class="servicexcell-mob-img-en">
            <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/service_excellence.png"} alt="service excellence" />
          </div>
          
          <p class="servicexcell-mob-txt-en">KR Insurance Services has got functional expertise into advisory services, underwriting, expert claims servicing and client retention services to ensure increased efficiency in the deliverables -  </p>
          
          <div class="servicexcell-pins-list-mob-en">
            <div class="servicexcell-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="servicexcell-pins-list-mob-item-en"><u>Advisory services</u> aim to achieve customer delight through dedicated client relationship management, risk inspections, policy audit, route surveys, wellness programs, credit reports renewal reminders etc.</div>

            <div class="servicexcell-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="servicexcell-pins-list-mob-item-en"><u>Specialist Underwriting</u> teams to arrange the best terms from insurers and re-insurers, ensuring complete cover of risk in hand.</div>

            <div class="servicexcell-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="servicexcell-pins-list-mob-item-en"><u>Expert Claims servicing</u> teams work towards smooth claim settlement across business lines ensuring business continuity.</div>

            <div class="servicexcell-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="servicexcell-pins-list-mob-item-en"><u>Dedicated Retention team</u> for exceeding client’s service expectations and retaining clients with us on a year to year basis.</div>
          </div>

          <h3 class="servicexcell-whykrinsu-mob-title-en">Why KR Insurance Services ?</h3>

          <div class="servicexcell-mob-whykrlist-en">
            <div class="servicexcell-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
            <div class="servicexcell-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
            <div class="servicexcell-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
            <div class="servicexcell-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
          </div>
          
          </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default ServiceExcellence;
